import API, { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";

const createAppLog = async (object) => {
  try {
    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.createAppLog, { input: object })
    );
    return response.data.createAppLog;
  } catch (error) {
    console.error("Error creating AppLog:", error);
    throw error;
  }
};

const updateAppLog = async (id, args) => {
  try {
    // First, fetch the current version of the AppLog
    const getAppLogResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getAppLog, { id })
    );
    const currentAppLog = getAppLogResponse.data.getAppLog;

    // Prepare the update input
    const updateInput = { id, _version: currentAppLog._version };
    args.forEach((arg) => {
      updateInput[arg.property] = arg.value;
    });

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.updateAppLog, { input: updateInput })
    );
    return response.data.updateAppLog;
  } catch (error) {
    console.error("Error updating AppLog:", error);
    throw error;
  }
};

const deleteAppLog = async (id) => {
  try {
    // First, fetch the current version of the AppLog
    const getAppLogResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getAppLog, { id })
    );
    const currentAppLog = getAppLogResponse.data.getAppLog;

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.deleteAppLog, {
        input: { id, _version: currentAppLog._version },
      })
    );
    return response.data.deleteAppLog;
  } catch (error) {
    console.error("Error deleting AppLog:", error);
    throw error;
  }
};

const getAppLogsByWorkspaceID = (workspaceID) =>
  makeGraphQLRequest(
    graphqlOperation(queries.appLogsByWorkspace, { workspaceID: workspaceID })
  );

export default {
  createAppLog,
  updateAppLog,
  deleteAppLog,
  getAppLogsByWorkspaceID,
};
